import { getTimezoneDate, isBefore } from '../dateUtils'

export const timeInFuture = (date, tz) => {
  const currentTimeTZ = getTimezoneDate(tz)
  const receivedDate = new Date(date)
  if (isBefore(receivedDate, currentTimeTZ)) {
    return 'Time is in the past'
  }
}

export default timeInFuture
